import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'status'
})
export class StatusPipe implements PipeTransform {
  transform(value: number | null | undefined): {
    text: string;
    className: string | null;
  } {
    if (value === null || value === undefined) {
      return { text: '—', className: null };
    }

    switch (value) {
      case 1:
        return {
          text: 'Ativo',
          className: 'status-ativo'
        };
      case 2:
        return {
          text: 'Encerrado',
          className: 'status-encerrado'
        };
      default:
        return {
          text: 'Encerrado',
          className: null
        };
    }
  }
}
